import LanguageDropdown from "components/Language/LanguageDropdown"
import React, { Component,useEffect } from "react"
import { Link, withRouter } from "react-router-dom"
import {Button, Icon, Message, Modal, Form,Checkbox,Dropdown,TextArea, FormField, FormInput} from "semantic-ui-react"
 //ELEM REACT16 CHANGE
import queryString from "qs"
import shop from "shop/shop"
import FormCMS from "components/Form/FormCMS"
import WordPressContainer from "WordPressContainer"
import languageStore from "stores/languageStore"

@withRouter
export default class NewCustomerPage extends Component {

	state = {
			form1Disabled: false,
			form2Disabled: true,
			form3Disabled: true,
			form4Disabled: true,
			form1Check: false,
			form2Check: false,
			form4Check: false,
			newcust: {
				firm: {
					name: "",
					uidnr: "",
					glnnr: "",
					customernumber: ""
				},
				person: {
					salutation: "",
					firstname: "",
					lastname: ""
				},
				address: {
					street: "",
					streetnumber: "",
					addition: "",
					postcode: "",
					city: "",
					country: "",
					deliverstreet: "",
					deliverstreetnumber: "",
					deliveraddition: "",
					deliverpostcode: "",
					delivercity: "",
					delivercountry: ""
				},
				contact: {
					email: "",
					phone: "",
					mobile: "",
					web: "",
					comment: ""
				},
				locale: ""
			}
		}

	handleSendCustReg = async (newCustomer) =>{
		const { currentLanguage } = languageStore
		newCustomer.locale = currentLanguage
		if(this.state.newcust.contact.email == "" || this.state.newcust.contact.phone == ""){
			shop.toast(translate("Bitte alle Pflichtfelder ausfüllen!"))
			return
		}
		this.state.newcust.address.street = this.state.newcust.address.street + ' ' + this.state.newcust.address.streetnumber
		this.state.newcust.contact.mobile = ' '
		try {
		await shop.fetch( `/shop/rest/service/request?id=customer_registration`, {
			method: "POST",
			body: JSON.stringify( newCustomer )
		} )
		shop.toast( "Kundenregistrierung erfolgreich!" )
		console.log("newcust: ", this.state.newcust)
		const delay = ms => new Promise(
			resolve => setTimeout(resolve, ms)
		  );
		await delay(2000);
		this.props.history.push("/home");
		}
		catch (err) {
		console.log( err )
		shop.toast( err )
		}
	}
	
	handleFormClearWeiter = ( ) => {
		console.log("CUSTNUMBER: ",this.state.newcust.firm.customernumber, " LENGTH: ", this.state.newcust.firm.customernumber.length)
		if(this.state.newcust.firm.customernumber != ""){
			if(this.state.newcust.firm.customernumber.length > 8 || this.state.newcust.firm.customernumber.length < 8){
				shop.toast(translate("Keine gültige Kundennummer angegeben!"))
				return
			}
		}
		if(this.state.newcust.firm.name == "" || this.state.newcust.person.salutation == "" || this.state.newcust.person.firstname == "" || this.state.newcust.person.lastname == ""){
			//shop.toast("Alles eingegeben!")
			shop.toast(translate("Bitte alle Pflichtfelder ausfüllen!"))
			return
		} else if(this.state.form2Disabled == false ){
			if(this.state.newcust.address.street == "" || this.state.newcust.address.postcode == "" || this.state.newcust.address.city == "" || this.state.newcust.address.country == ""){
				shop.toast(translate("Bitte alle Pflichtfelder ausfüllen!"))
				return
			} else if(this.state.form4Disabled == false){
				if(this.state.newcust.contact.mobile == "" || this.state.newcust.contact.phone == ""){
					shop.toast(translate("Bitte alle Pflichtfelder ausfüllen!"))
					return
				}
			}
		}

		if(this.state.form1Disabled == false && this.state.form3Disabled == true){
			this.setState( { form1Disabled: true } )
			this.setState( { form2Disabled: false } )
			this.setState( { form3Disabled: true } )
		}
		else if(this.state.form2Disabled == false && this.state.form3Disabled == true){
			this.setState( { form1Disabled: true } )
			this.setState( { form2Disabled: true } )
			this.setState( { form4Disabled: false } )
		}
		else if(this.state.form3Disabled == false){
			this.setState( { form1Disabled: true } )
			this.setState( { form2Disabled: true } )
			this.setState( { form3Disabled: true } )
			this.setState( { form4Disabled: false } )
		}
		}
	
	handleFormClearDelivery = ( ) => {
		if(this.state.form2Disabled == false ){
			if(this.state.newcust.address.street == "" || this.state.newcust.address.postcode == "" || this.state.newcust.address.city == "" || this.state.newcust.address.country == ""){
				shop.toast(translate("Bitte alle Pflichtfelder ausfüllen!"))
				return
			}
		}
		this.setState( { form1Disabled: true } )
		this.setState( { form2Disabled: true } )
		this.setState( { form3Disabled: false } )
		this.setState( { form4Disabled: true } )
	}

	handleFormClearZurueck  = ( ) => {
		if(this.state.form2Disabled == false){
			this.setState( { form1Disabled: false } )
			this.setState( { form2Disabled: true } )
		}
		else if(this.state.form3Disabled == false){
			this.setState( { form2Disabled: false } )
			this.setState( { form3Disabled: true } )
		}
		else if(this.state.form4Disabled == false){
			if(this.state.newcust.address.deliverstreet == ""){
				this.setState( { form2Disabled: false } )
				this.setState( { form4Disabled: true } )
			}
			else{
				this.setState( { form3Disabled: false } )
				this.setState( { form4Disabled: true } )
			}
		}
		}
	  
	render() {
		const countryOptions = [
			{ key: 'de', value: 'de', flag: 'de', text: 'Deutschland' },
			{ key: 'x', value: 'x', flag: 'x', text: 'Andere' },
		  ]
		  const { currentLanguage } = languageStore
		  let genderOptions =[ ]
		  if(currentLanguage == 'fr'){
			genderOptions = [
				{ key: 'male', value: 'Herr', text: 'Monsieur' },
				{ key: 'female', value: 'Frau', text: 'Madame' },
			]
		  }
		  else{
			genderOptions = [
				{ key: 'male', value: 'Herr', text: 'Herr' },
				{ key: 'female', value: 'Frau', text: 'Frau' },
			]
		  }

		  const handleChange = (event) => {
			console.log("CHANGE: ", event.target)
			let tempname = event.target.name
			let tempname2 = event.target.className
			let tempvalue = event.target.value
			this.setState(prevState => {
				let newcust = { ...prevState.newcust };  
				newcust[tempname][tempname2] = tempvalue;       
				return { newcust }; 
			  })
		  };  
		  const handleDropDownChange = (event, {value}) => {
			let tempvalue = value
			this.setState(prevState => {
				let newcust = { ...prevState.newcust };  
				if(value == "Herr" || value == "Frau"){
					newcust.person.salutation = tempvalue
				} 
				else if(this.state.form2Disabled == false){
					newcust.address.country = tempvalue
				} 
				else if(this.state.form3Disabled == false){
					newcust.address.delivercountry = tempvalue
				}     
				return { newcust }; 
			  })
		  }; 
		
		 const handleCommentChange = ( event ) => {
			console.log("VALUE:",event.target)
			let comment = event.target.value
			this.setState(prevState => {
				let newcust = { ...prevState.newcust };  
				newcust.contact.comment = comment;       
				return { newcust }; 
			  })
		  }

		const query = queryString.parse( this.props.location.search.substr( 1 ) )
		const { overlay } = query
		const { history } = this.props
		return (
			<div>
				{overlay && <Modal open={true}>
					<Button
						className="absolute right-1 top-1"
						as={Link}
						to={this.props.location.pathname}
						circular
						basic
						icon={"close"}
					/>
					<Modal.Content>
						<WordPressContainer slug={overlay}/>
					</Modal.Content>

					<Modal.Actions>
						<Button
							as={Link}
							to={this.props.location.pathname}
							labelPosition="right"
							content="Zurück"
						/>
					</Modal.Actions>

				</Modal>}
				<div className="pa3">
					<div className="fr"> <LanguageDropdown/></div>
					<Button as={Link} to="/login"><Icon name="chevron left"/>{translate( "back to login" )}</Button>

				</div>
				<div className="mw7 center pt2 pb6">

					<div className="tc pb4">
						<Link to="/login">
							<img src={shop.config.logo} title="Zur Startseite"/>
						</Link>
					</div>

					{/*<div className="center  pb3">
						<Message>
							<div className="b">{translate("LOGIN_NOTICE_HEADER")}</div>

							<div>{translate("LOGIN_NOTICE1")} <a href="https://shop.orthowalker-kieferorthopaedie.ch/reset_password/">https://shop.orthowalker-kieferorthopaedie.ch/reset_password/</a>
							 {translate("LOGIN_NOTICE2")} <a href="mailto:shop@orthowalker.ch">shop@orthowalker.ch</a>
							 {translate("LOGIN_NOTICE3")}<a href="tel:056 649 24 00">056 649 24 00</a> / <a href="mailto:info@orthowalker.ch">info@orthowalker.ch</a><a>).</a>						
							</div>

							<div className={"tc pt3"}>
								<Button as={Link} to={"/request_password"}>{translate("Passwort anfordern")}</Button>
							</div>
						</Message>
					</div>*/}	

				<h1>{translate("Neukundenregistrierung")}</h1>
				{translate("Mit dem folgenden Formular können Sie sich als Neukunde der Frankenstolz registrieren. Füllen Sie dazu bitte alle Felder im Formular aus und klicken Sie dann auf die Schaltfläche »Zugang beantragen«")}
				<br/><br/>

				<strong>{translate("Bitte beachten Sie:")}</strong><br/><br/>

				{translate("Wir werden Ihre Anmeldung überprüfen und Ihren Zugang schnellstmöglich freischalten. Nach der Freischaltung erhalten Sie die Zugangsdaten per E-Mail. Erst dann können Sie sich in unserem Shop einloggen. Es können nur Kunden aus Deutschland neu registriert werden.")}
				<br/><br/>

				{this.state.form1Disabled == false && <Form>
					<div style={{minHeight: "400px"}}>
					<h3>{translate("Angaben zum Unternehmen")}</h3>
						<Form.Field required>
							<label>{translate("Firmenname")}</label>
							<input value={this.state.newcust.firm.name} onChange={handleChange} className="name" name="firm" placeholder={translate("Firmenname")} />
						</Form.Field>
						{/*<Form.Field>
							<label>{translate("GLN-Nummer")}</label>
							<input value={this.state.newcust.firm.uidnr} onChange={handleChange}  className="uidnr" name="firm" placeholder={translate("GLN-Nummer")} />
						</Form.Field>
						<Form.Field>
							<label>{translate("Kundennummer")}</label>
							<input value={this.state.newcust.firm.customernumber} onChange={handleChange}  className="customernumber" name="firm" placeholder={translate("Kundennummer")} />
				</Form.Field>*/}
						<Form.Group widths="equal">
						<Form.Input label={translate("GLN-Nummer")}><input fluid value={this.state.newcust.firm.glnnr} onChange={handleChange} className="glnnr" test="firstname" name="firm" label="GLN-Nummer:" placeholder={translate("GLN-Nummer")}  /></Form.Input>
						<Form.Input label={translate("Kundennummer (Falls vorhanden)")}><input fluid value={this.state.newcust.firm.customernumber} onChange={handleChange} className="customernumber" name="firm" label="Kundennummer:" placeholder={translate("Kundennummer")}  /></Form.Input>
						<Form.Input label={translate("UID-Nummer")}><input fluid value={this.state.newcust.firm.uidnr} onChange={handleChange} className="uidnr" name="firm" label="Kundennummer:" placeholder={translate("UID-Nummer")}  /></Form.Input>
					</Form.Group>
					<br/>
					<h3>{translate("Angaben zu Ihrer Person")}</h3>
					<Form.Field required>
						<label>{translate("Anrede")}</label>
						<Dropdown
							value={this.state.newcust.person.salutation}
							onChange={handleDropDownChange}
							clearable
							label="Land:"
							className="salutation" 
							name="person"
							required
							selection
							options={genderOptions}
							placeholder={translate("Anrede")}
						/>
					</Form.Field>
					<Form.Group widths="equal">
						<Form.Input required label={translate("Vorname")}><input fluid value={this.state.newcust.person.firstname} onChange={handleChange} className="firstname" test="firstname" name="person" label="Vorname:" placeholder={translate("Vorname")}  /></Form.Input>
						<Form.Input required label={translate("Nachname")}><input fluid value={this.state.newcust.person.lastname} onChange={handleChange} className="lastname" name="person" label="Nachname:" placeholder={translate("Nachname")}  /></Form.Input>
					</Form.Group></div>
				</Form>}
				{this.state.form2Disabled == false && <Form>
					<div style={{minHeight: "400px"}}>
					<h3>{translate("Angaben zur Rechnungsadresse")}</h3>
						<Form.Group widths="equal">
							<Form.Input width={13} required label={translate("Strasse")}><input value={this.state.newcust.address.street} onChange={handleChange} required fluid className="street" name="address" label="street:" placeholder={translate("Strasse")}  /></Form.Input>
							<Form.Input width={3} required label={translate("Hausnummer")}><input value={this.state.newcust.address.streetnumber} onChange={handleChange} required fluid className="streetnumber" name="address" label="street:" placeholder={translate("Hausnummer")}  /></Form.Input>
						</Form.Group>
						<Form.Field>
							<label>{translate("Zusatz")}</label>
							<input value={this.state.newcust.address.addition} onChange={handleChange} className="addition" name="address" nameadd="street" placeholder={translate("Zusatz")} />
						</Form.Field>
						<Form.Group widths="equal">
							<Form.Input required label={translate("PLZ")}><input value={this.state.newcust.address.postcode} onChange={handleChange} required fluid className="postcode" name="address" label="PLZ:" placeholder={translate("PLZ")}  /></Form.Input>
							<Form.Input required label={translate("Ort")}><input value={this.state.newcust.address.city} onChange={handleChange} required fluid className="city" name="address" label="Ort:" placeholder={translate("Ort")}  /></Form.Input>
						</Form.Group>
						<Form.Field required>
						<label>{translate("Land")}</label>
						<Dropdown
							value={this.state.newcust.address.country}
							onChange={handleDropDownChange}
							clearable
							label="Land:"
							className="country" 
							name="address"
							required
							
							selection
							options={countryOptions}
							placeholder={translate("Land")}
						/>
						</Form.Field>
					</div>
  				</Form>}

				  {this.state.form3Disabled == false && <Form>
					<div style={{minHeight: "400px"}}>
					<h3>{translate("Angaben zur Lieferadresse")}</h3>
					<Form.Group widths="equal">
							<Form.Input width={13}  label={translate("Strasse")}><input value={this.state.newcust.address.deliverstreet} onChange={handleChange} required fluid className="deliverstreet" name="address" label="street:" placeholder={translate("Strasse")}  /></Form.Input>
							<Form.Input width={3}  label={translate("Hausnummer")}><input value={this.state.newcust.address.deliverstreetnumber} onChange={handleChange} required fluid className="deliverstreetnumber" name="address" label="street:" placeholder={translate("Hausnummer")}  /></Form.Input>
						</Form.Group>
						<Form.Field>
							<label>{translate("Zusatz")}</label>
							<input value={this.state.newcust.address.deliveraddition} onChange={handleChange} className="deliveraddition" name="address" nameadd="street" placeholder={translate("Zusatz")} />
						</Form.Field>
						<Form.Group widths="equal">
							<Form.Input  label={translate("PLZ")}><input value={this.state.newcust.address.deliverpostcode} onChange={handleChange}  fluid className="deliverpostcode" name="address" label="PLZ:" placeholder={translate("PLZ.")}  /></Form.Input>
							<Form.Input  label={translate("Ort")}><input value={this.state.newcust.address.delivercity} onChange={handleChange}  fluid className="delivercity" name="address" label="Ort:" placeholder={translate("Ort")}  /></Form.Input>
						</Form.Group>
						
						<Form.Field >
						<label>{translate("Land")}</label>
						<Dropdown
							value={this.state.newcust.address.delivercountry}
							onChange={handleDropDownChange}
							clearable
							label="Land:"
							className="delivercountry" 
							name="address"
							required
							
							selection
							options={countryOptions}
							placeholder={translate("Land")}
						/>
						</Form.Field>
					</div>
  				</Form>}
				  {this.state.form4Disabled == false && <Form>
					<div style={{minHeight: "400px"}}>
					<h3>{translate("Erreichbarkeit")}</h3>
						<Form.Field required>
							<label>{translate("E-Mail")}</label>
							<input value={this.state.newcust.contact.email} onChange={handleChange} className="email" name="contact" nameadd="email" placeholder={translate("E-Mail")} />
						</Form.Field>
						<Form.Field>
							<label>{translate("Webseite")}</label>
							<input value={this.state.newcust.contact.web} onChange={handleChange} className="web" name="contact" nameadd="email" placeholder="frankenstolz.de/" />
						</Form.Field>
						<Form.Group widths="equal">
						<Form.Input required label={translate("Telefon")}><input value={this.state.newcust.contact.phone} onChange={handleChange} required fluid className="phone" name="contact" label="Telefon:" placeholder={translate("Telefon")}  /></Form.Input>
						<Form.Input label={translate("Mobil")}><input value={this.state.newcust.contact.mobile} onChange={handleChange} fluid className="mobile" name="contact" label="Mobil:" placeholder={translate("Mobil")}  /></Form.Input>
						</Form.Group>
						<FormField label={translate( "comment" )} htmlFor="supported-controls-input">
							   <FormInput placeholder={translate( "commentPlaceholder" )} value={this.state.newcust.contact.comment} onChange={handleCommentChange} multiline/>
              			</FormField>
						</div>
  				</Form>}
				  <div style={{ display: "flex" }} >
				  {this.state.form1Disabled == true && <Button onClick={this.handleFormClearZurueck} primary>
                    {translate( "Zurück" )}
                    <i className="icon-angle-right"/>
                  </Button>}
				  {this.state.form2Disabled == false && <Button style={{ marginLeft: "auto" }} onClick={this.handleFormClearDelivery} primary>
                    {translate( "Separate Lieferadresse eingeben" )}
                    <i className="icon-angle-right"/>
                  </Button>}
  				{this.state.form4Disabled == true && 
		
					<Button style={{ marginLeft: "auto" }} onClick={this.handleFormClearWeiter} primary>
                    {translate( "Weiter" )}
                    <i className="icon-angle-right"/>
                  </Button>}
				  {this.state.form4Disabled == false && <Button style={{ marginLeft: "auto" }} onClick={() => this.handleSendCustReg(this.state.newcust)} primary>
                    {translate( "Zugang beantragen" )}
                    <i className="icon-angle-right"/>
                  </Button>}
				  </div>

					{/*<FormCMS slug={"customer_registration"} onSuccess={() => {
						history.push( "/login" )
						window.swal( translate("Neukundenanmeldung erhalten"), translate("Vielen Dank für Ihre Anmeldung. Sie erhalten Ihre Anmeldedaten per E-Mail"), "success" )
					}}/>*/}
				</div>
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/theme/lindt/pages/NewCustomerPage.js